export const COEFF_FOR_ZOOM = 1.86;
export const DATA_ELEM_ZOOM_BASE = 'zoom';
export const DATA_ELEM_ZOOM_PREVIEW = `${DATA_ELEM_ZOOM_BASE}_preview`;
